import {CallFunction} from "../../public/bundles/w3comhulk/callFunction";

export const sendRetardTransportOnEmail = (rows) => {
    var callFunction = new CallFunction('sendRetardTransportOnEmail','fad fa-paper-plane fa-2x');
    callFunction.modalBody.innerHTML = '';
    callFunction.showModal('Envoyer les documents par email.')
    if (!callFunction.checkRowsLength(rows, 1, callFunction)) {
        return;
    }
    var objWithoutErrors = [];
    rows.map(function (el, index) {
        if (el.TransporteurEmails === '') {
           callFunction.addLineResult('Transporteur ' + el.Transporteur + ' : L\'email du transporteur n\'est pas renseigné.', 'danger')
        } else {
            objWithoutErrors.push(el);
            callFunction.addLineResult( el.Transporteur + ' : ' + el.TransporteurEmails, 'success')
        }
    });

    var param = {
        'sendMailList': objWithoutErrors
    };

    if (objWithoutErrors.length !== 0) {
        callFunction.addValidateBtn(function () {
            callFunction.startLoading();
            $.post(urls.sendRetardTransport, param, function (rep) {
                window.location.reload();
            }).fail(function () {
                window.location.reload();
            })
        });
    }
};


// WEBPACK FOOTER //
// ./assets/js/display_retard_transport.js